import { render } from "./PlaybookViewDocument.vue?vue&type=template&id=1cc42de8&scoped=true"
import script from "./PlaybookViewDocument.vue?vue&type=script&lang=js"
export * from "./PlaybookViewDocument.vue?vue&type=script&lang=js"

import "./PlaybookViewDocument.vue?vue&type=style&index=0&id=1cc42de8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc42de8"]])

export default __exports__